'use strict';

import {localDataStorageProvider} from "../../services/localdatastorageprovider.js";
//import {invitationModel} from "../../models/invitationmodel.js";

export class ListCtrl
{
	storageNames = {
		query: 'ListCtrlQuery'
	};
	
	columnsData = {
		columns: {},
		footer: null
	};
	resultOptions = {
		boundaryLinks: false,
		limitSelect: true,
		pageSelect: true
	};
	limitOptions = [10, 20, 50, 100];
	query = {
		order: '',
		limit: 20,
		page: 1,
		filters: {}
	};
	defaultQuery = {
		order: '',
		limit: 20,
		page: 1,
		filters: {}
	};
	
	classif = {};
	chips = [];
	promise;
	
	data = [];
	total = 0;
	initialized = false;
	
	$filter;
	$locale;
	$scope;
	
	jsDataService;
	$http;
	
	
	
	cfg = {
		procedureRegister: {},
		itemsImport: {
			allow: false
		}
	};
	
	selectedRows = [];

	queryValueCopy = '';
	queryTimer;
	
	
	constructor($scope, $http, $filter, $timeout, $locale, jsDataService){
		'ngInject';
		this.$filter = $filter;
		this.$scope = $scope;
		this.$http = $http;
		this.$timeout = $timeout;
		this.$locale = $locale;
		this.jsDataService = jsDataService;
		this.classif = this.jsDataService.get('cfgClassif', {});
		
//		let myModel = new invitationModel({title: 'La'}, $filter);
	}
	
	$onInit(){
		for(let str in this.storageNames){
			this.storageNames[str] = this.jsDataService.get('cfgAppName', '') + this.storageNames[str];
		}
		this.initColumns();
		this.initQuery();

		if (Array.isArray(this.jsDataService.data.cfgCallNumbers)) {
			this.jsDataService.data.cfgCallNumbers = Array.from(new Set(this.jsDataService.data.cfgCallNumbers));
		}
		this.initialized = true;
//		this.loadData();
		this.$scope.$watch('ctrl.queryValueCopy',()=>{
			this.$timeout.cancel(this.queryTimer);
			this.queryTimer = this.$timeout(()=>{
				this.query.filters.query.value = this.queryValueCopy;
			}, 500);
		});
	}
	
	initColumns(){
		this.columnsData.columns = this.jsDataService.get('cfgDisplayColumns', {});
		let footer = this.jsDataService.get('cfgFooterColumns');
		if(footer){
			this.columnsData.footer = footer;
		}
	}
	
	initQuery(){
		const params = ['value'];
		this.defaultQuery = angular.merge({}, this.getDefaultQuery(), this.jsDataService.get('cfgQuery', {}));
		const tiny = this.getTinyDataForStorage(this.defaultQuery.filters, params);
		let storing = angular.copy(this.defaultQuery);
		storing.filters = tiny;
		const stored = new localDataStorageProvider(this.storageNames.query, storing);
		this.query = angular.merge({}, this.defaultQuery, stored.getData());
		const urlParams = new URLSearchParams(window.location.search);
//		const number = urlParams.get('number');
//		if(null !== number){
//			this.query = angular.merge({}, this.defaultQuery, stored.getEmptyDataSet());
//			this.query.filters.number.value = number;
//		}

		if(this.query.filters.query.value !== ''){
			this.queryValueCopy = this.query.filters.query.value;
		}
		const self = this;
		this.$scope.$watch(function(){
			return angular.toJson(self.query);
		},function(){
			let toStore = angular.copy(self.query);
			toStore.filters = self.getTinyDataForStorage(toStore.filters, params);
			stored.setData(toStore);
			self.setChips();
			self.loadData();
		});
		
	}
	
	isFilters(){
		var o = angular.copy(this.query.filters);
		var d = angular.copy(this.defaultQuery.filters);
//		delete o.query;
//		delete d.query;
		if(angular.equals(o, d)){
			return false;
		}
		return true;
	}
	
	getFilterChips(){
		let chips = [];
		for(let i in this.query.filters){
			if(this.query.filters[i].isChip && this.query.filters[i].value && !angular.equals(this.query.filters[i].value, this.defaultQuery.filters[i].value)){
				chips.push({
					key: i,
					field: this.query.filters[i].field,
					title: this.query.filters[i].title,
					value: this.getChipValue(this.query.filters[i], true)
				});
			}
		}
		return chips;
	}
	
	getChipValue(field){
		let classifName = (typeof(field.classifName) !== 'undefined') ? field.classifName : field.field;
		if(field.type === 'classif' && typeof(this.classif[classifName]) !== 'undefined'){
			if(typeof(field.value) === 'object'){
				let values = [];
				for(let oneVal of field.value){
					let val = this.$filter('filter')(this.classif[classifName], {id: oneVal}, true);
					if(val.length > 0){
						let v = val.shift().title;
						if(v.length > 50 && arguments[1]){
							v = this.$filter('limitTo')(v, 50) + '...';
						}
						values.push(v);
					}
				}
				if(values.length > 0){
					return values.join(', ');
				}
				else{
					return null;
				}
			}
			else{
				let val = this.$filter('filter')(this.classif[classifName], {id: field.value}, true);
				if(val.length > 0){
					let v = val.shift().title;
					if(v.length > 50 && arguments[1]){
						v = this.$filter('limitTo')(v, 50) + '...';
					}
					return v;
				}
				else{
					return null;
				}
			}
		}
		else if(field.type === 'datepicker' && typeof(field.value) !== 'undefined' && field.value !== ''){
			let format = this.$locale.DATETIME_FORMATS.shortDate;
			return this.$filter('date')(field.value, format);
		}
		else{
			return field.value;
		}
	}
	
	getCustomClasssifValue(field, defaultValue){
		let val = this.getChipValue(field);
		if((null === val || val === '') && defaultValue){
			return defaultValue;
		}
		return val;
	}
	
	setChips(){
		this.chips = this.getFilterChips();
	}
	
	removeChip(chip){
		this.chips = [];
		if(typeof(this.query.filters[chip.key]) !== 'undefined'){
//			this.clearFilterField(this.query.filters[chip.key]);
			this.clearFilterKey(chip.key);
		}
		const self = this;
		setTimeout(function(){
			self.setChips();
		}, 20);
	}
	
	clearFilterField(filterField){
		filterField.value = '';
	}
	
	clearFilterKey(key){
		if(typeof(this.query.filters[key]) !== 'undefined'){
			if(typeof(this.defaultQuery.filters[key]) !== 'undefined'){
				this.query.filters[key].value = this.defaultQuery.filters[key].value;
				if(key==='query'){
					this.queryValueCopy = this.query.filters[key].value;
				}
			}
			else{
				this.query.filters[key].value = '';
				this.queryValueCopy = '';
			}
		}
	}
	
	clearFilters(){
		this.query.filters = angular.copy(this.getDefaultQuery().filters);
		this.queryValueCopy = '';
	}
	
	getDefaultQuery(){
		return this.defaultQuery;
	}
	
	getDisplayColumns(){
		return this.$filter('filter')(Object.values(this.columnsData.columns), {show: true}, true);
	}
	
	columnSort(col){
		if(col.sort){
			return col.id;
		}
		return null;
	}
	
	getColValue(row, col){
		if(typeof(row[col]) === 'undefined'){
			return '';
		}
		return row[col];
	}
	
	loadData(){
		if(this.initialized){
			const url = this.jsDataService.get('cfgDataUrl');
			if(url){
				this.promise = this.$scope.basicHttpConfigProcess({
					url: url,
					method: 'GET',
					params: this.query
				}).then((response) => {
					if(response.data.success){
						this.setData(response.data.data);
						this.total = response.data.total;
						this.setTotals(response.data);
					}
				}, () => {});
			}
		}
	}
	
	setData(data){
		this.data = data;
	}
	
	setTotals(response){
		if(typeof(response.totals) !== 'undefined' && this.columnsData.footer){
			for(let fel in this.columnsData.footer){
				if(typeof(response.totals[fel]) !== 'undefined'){
					this.columnsData.footer[fel].value = response.totals[fel];
				}
			}
		}
	}
	
	getPromiseState(){
		return this.promise.$$state.status;
	}

	getTinyDataForStorage(obj, param){
		let outp = {};
		for(let i in obj){
			outp[i] = {};
			for(let k of param){
				if(typeof(obj[i][k]) !== 'undefined'){
					outp[i][k] = obj[i][k];
				}
			}
		}
		return outp;
	}
	
	getFooterData(col){
		if(typeof(this.columnsData.footer[col]) !== 'undefined'){
			return this.columnsData.footer[col].value;
		}
		return '';
	}
}

